// Modules
import { gql } from '@apollo/client'

export const getLabsViewer = gql`
    {
        labs(group: "dasa") {
            name
            title
            status
        }
    }
`

export const getReportsHistory = gql`
    {
        reportsHistory {
            id
        }
    }
`
export const viewer = gql`
    {
        viewer {
            birthDate
            cep
            federalTaxId
            biologicalSex
            viewerHealthInsurance {
                id
                name
                number
                ans
                type
            }
            partnerHealthInsurance {
                name
            }
            name
            socialName
            email
            phone
            id
            responsibleType
            responsibleOf {
                birthDate
                cep
                federalTaxId
                biologicalSex
                viewerHealthInsurance {
                    id
                    name
                    number
                    ans
                    type
                }
                partnerHealthInsurance {
                    name
                }
                name
                socialName
                email
                phone
                id
                responsibleType
            }
        }
    }
`

export const GetMagicLinkById = gql`
    query getMagicLinkById($id: String!) {
        getMagicLinkById(id: $id) {
            patientName
            isUsed
            isAttemptLimitExceeded
            isExpired
            createdAt
        }
    }
`
